import React from 'react';
import { BsViewList } from '@react-icons/all-files/bs/BsViewList';

import { decorateComponent } from '../../documentComponents';
import { Accordion } from './Accordion';
import { AccordionInspector } from './Accordion.Inspector';

const AccordionExpandButtonNode = {
  key: null,
  type: 'accordionButton',
  props: { action: 'expand' },
  children: [],
};

const AccordionCollapseButtonNode = {
  key: null,
  type: 'accordionButton',
  props: { action: 'collapse' },
  children: [],
};

const AccordionContentNode = {
  key: null,
  type: 'accordionContent',
  props: {},
  children: [],
};

export default decorateComponent(Accordion, 'block', {
  id: 'accordion',
  label: '아코디언',
  defaultProps: {
    buttonPlacement: 'bottom',
    children: [
      AccordionExpandButtonNode,
      AccordionCollapseButtonNode,
      AccordionContentNode,
    ],
  },
  allowedChildren: [],
  disallowedAncestors: [
    'a',
    'coupon',
    'tabButton',
    'carousel',
    'accordion',
  ],
  renderIcon: () => <BsViewList />,
  renderInspector: AccordionInspector,
});
